import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { EnrichedParentStopPlace } from '../../../../../../types';
import { EditTerminalValidityResult } from '../../Types';
import { TerminalValidityForm } from './TerminalValidityForm';
import { useEditTerminalValidityFormUtils } from './useEditTerminalValidityFormUtils';

type EditTerminalValidityFormProps = {
  readonly className?: string;
  readonly onCancel: () => void;
  readonly onEditDone: (result: EditTerminalValidityResult) => void;
  readonly terminal: EnrichedParentStopPlace;
};

export const EditTerminalValidityForm: FC<EditTerminalValidityFormProps> = ({
  className,
  terminal,
  onCancel,
  onEditDone,
}) => {
  const { methods, onFormSubmit } = useEditTerminalValidityFormUtils(
    terminal,
    onEditDone,
  );

  return (
    <FormProvider {...methods}>
      <TerminalValidityForm
        className={className}
        onCancel={onCancel}
        onSubmit={methods.handleSubmit(onFormSubmit)}
      />
    </FormProvider>
  );
};
